<template>
  <div class="content">
    <TabSwitch
      class="TabSwitch"
      v-model="check"
      :tabs="[
        { label: '工单管理', value: 'a' },
        { label: '随访计划', value: 'b' }
      ]"
    />

    <WorkMange v-if="check === 'a'" />
    <FollowupPlan v-else-if="check === 'b'" />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import FollowupPlan from './FollowupPlan.vue'
import WorkMange from './WorkMange.vue'
import TabSwitch from '../../../components/TabSwitch.vue'
const check = ref('a')
</script>

<style lang="scss" scoped>
.content {
  background: white;
  padding: 16px;
  .TabSwitch {
    margin-bottom: 12px;
  }
}
</style>
